import { FC } from 'react';

import { Table } from 'antd';
import { Typography } from 'ui';

import s from './ChangeLog.module.scss';

const changelogData = [
  { version: 'v2.0.0', date: '2025-02-22', changes: 'Fixed svg seating plan issue.' },
  {
    version: 'v2.0.1',
    date: '2025-02-24',
    changes: `-Added admin UI to display change log.
          -Moved Export Code to admin page
          -Reduced Map image size (first page)
          -Reduced Seating Plan image Preview
          -Moved Seating Plan menu Under Ticket Types (fixed ticket edit issue)
          -Tax page country dropdown fixed`,
  },
  {
    version: 'v2.0.2',
    date: '2025-02-25',
    changes: 'Added Section item menu. Ticket caption fixed',
  },
  {
    version: 'v2.0.3',
    date: '2025-02-25',
    changes: 'VAT charge field error fixed',
  },
  {
    version: 'v2.0.4',
    date: '2025-02-26',
    changes: `-Navigation menu scroll removed and David work (brand menu), 
    -Organiser & billing page merged in 1 page
    -added tab in Organiser & biliing page
    -Fixed Left menu font size `,
  },
  {
    version: 'v2.0.5',
    date: '2025-02-27',
    changes: `-Fixed UI differences across system
    -Organiser link effect fixed when bank-link, 
   `,
  },
  {
    version: 'v2.0.6',
    date: '2025-03-04',
    changes: `-Refrral team page
    - Sales Channels page
   `,
  },
  {
    version: 'v2.0.7',
    date: '2025-03-06',
    changes: `-Refrral team page bug fixed
    -Iframe page added
   `,
  },
  {
    version: 'v2.0.8',
    date: '2025-03-13',
    changes: `-Sales channel moved to tools
    -Referral links removed 
    -Fixed referral link list issue.
    -Event popover search fixed.
    -Right top event select UI issue fixed.
   `,
  },
  {
    version: 'v2.0.9',
    date: '2025-03-14',
    changes: `-Sales channel display name issue fixed
   -referral pagination added
   `,
  },
];

const ChangeLog: FC = () => {
  const columns = [
    { title: 'Version', dataIndex: 'version', key: 'version' },
    { title: 'Release Date', dataIndex: 'date', key: 'date' },
    {
      title: 'Bug Fixes / Changes',
      dataIndex: 'changes',
      key: 'changes',
      render: (text: string) => <div style={{ whiteSpace: 'pre-line' }}>{text}</div>,
    },
  ];
  return (
    <div className={s.wrapper}>
      <Typography type="h2" weight={700}>
        Change Log
      </Typography>
      <div style={{ marginTop: 32 }}></div>
      {/* <Button type="primary">Download CSV</Button> */}
      <Table
        dataSource={changelogData}
        columns={columns}
        scroll={{ x: 'max-content' }}
        rowKey="version"
        pagination={false}
        style={{ marginTop: 16 }}
      />
    </div>
  );
};

export default ChangeLog;
